import styled from "styled-components";
import { Row, Col, Button } from "react-bootstrap";

export const Street = styled.div`
    background-color: #205DBC;  
    width: 30px;
`;

export const MyCol = styled(Col)`
    display: flex;
    justify-content: space-evenly;
    flex-flow: column wrap;
    // height: 100%;
`;

export const MyRow = styled(Row)`
    display: flex;
    justify-content: center;
`;

export const MyContainer = styled.div`
    margin: 0 20px;
    margin-bottom: 10px;
`;

export const HorizontalStreet = styled.div`
    background-color: #205DBC;  
    height: 30px;
    width: 100%;
    text-align: center;
    line-height: 30px;
    color: #FAFAFA;
`;

export const AvailableBar = styled.div`
    background-color: #21BD11;
    border-radius: 50%;
    height: 13px;
    width: 13px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
`;

export const NotAvailableBar = styled.div`
    background-color: #F11F1F;
    border-radius: 50%;
    height: 13px;
    width: 13px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
`;

export const TemporarilyClosedBar = styled.div`
    background-color: #A86BFF;
    border-radius: 50%;
    height: 13px;
    width: 13px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 2px;
`;

export const AllBar = styled.div`
    background-color: gray;
    border-radius: 50%;
    height: 13px;
    width: 13px;
    box-shadow: 0 3px 10px -2px #E3E3E3;
    margin-top: 5px;
`;

export const LocCol1 = styled(Col)`
    text-align: center;
    font-size: 13px;
    display: block;
    // margin-left: -60px;
    @media screen and (max-width: 1200px) {
        // margin-left: 0px;  /* Reset margin for smaller screens */
        // width: 100%;       /* Take full width */
        // display: block;    /* Make sure it's block element for stacking */
    }
`;

export const LocRow1 = styled(Row)`
    display: flex;
    align-items: center;
    height: 30px;
    margin-top: 10px;
`;

export const Text = styled.div`
    display: none;
    @media screen and (min-width: 1400px) {
        display: block;
        position: absolute;
        margin-top: 993px;
        margin-left: 37%;
        height: 30px;
        text-align: center;
        font-size: 10px;
        width: 100px;
    }
`;

export const Search = styled(Button)`
    border-radius: 4px;
    background: #FAFAFA;
    outline: none;
    border: none;
    cursor: pointer;
    height: 40px;
    transform: translate(-5px, 5px);
    color: #2C2C2C;
    /* Second Nav */
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #E8E8E8;
        color: #666666;
    }
`;

export const ScrollButton = styled.div` 
   position: fixed;  
   right: 5%; 
   top: 20px; 
   height: auto; 
   font-size: 1rem; 
   z-index: 200; 
   cursor: pointer; 
   background-color: #205DBC;
   color: white;
   border-radius: 10px;
   padding: 10px;
   padding-top: 5px;
   justify-content: center;
   display: flex;
`

export const StreetBlockRow = styled(Row)`
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
    margin-top: 5px;
`;

export const LeftBlock = styled(Col)`
    align-items: flex-end;
    margin-right: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-flow: column wrap;
`;

export const RightBlock = styled(Col)`
    align-items: flex-start;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex-flow: column wrap;
`;

export const VerticalStreet = styled(Col)`
    width: 30px;
    display: grid;
    justify-content: center;
`;